import { render } from "./GrupoEmpleadoForm.vue?vue&type=template&id=354259d4&scoped=true"
import script from "./GrupoEmpleadoForm.vue?vue&type=script&lang=js"
export * from "./GrupoEmpleadoForm.vue?vue&type=script&lang=js"

import "./GrupoEmpleadoForm.vue?vue&type=style&index=0&id=354259d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354259d4"]])

export default __exports__